<template>
  <div v-if="coursesActives && coursesActives.length">
    <v-dialog v-if="courseSelect" v-model="dialogCourse" max-width="600" scrollable>
      <v-card>
        <v-card-title class="headline font-weight-bold flex-nowrap">
          {{ courseSelect.titulo }}
          <v-spacer></v-spacer>
          <v-btn icon @click="courseSelect = undefined; dialogCourse = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-subtitle class="d-flex flex-column">
          Para más información escríbenos
          <div class="d-flex align-center">
            <v-icon color="success" class="mr-2">mdi-whatsapp</v-icon>
            <span class="font-weight-bold success--text">{{siteSettings.redes_sociales.whatsapp}}</span>
          </div>
        </v-card-subtitle>
        <v-card-text>
          <v-img v-if="!courseSelect.video" :src="courseSelect.portada" contain></v-img>
          <iframe
            v-else
            style="width: 100%"
            height="409"
            :src="courseSelect.video.replace('watch?v=', 'embed/')"
            frameborder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
          <div class="mt-6 subtitle">{{ courseSelect.descripcion }}</div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-carousel cycle height="100" hide-delimiter-background show-arrows-on-hover>
      <v-carousel-item
        v-for="(course, index) of coursesActives"
        :key="index"
        :src="course.portada"
        style="cursor: pointer"
        @click.stop="courseSelect = course; dialogCourse = true;"
      >
        <div
          class="py-2 px-8"
          style="height: 80%; background-image: linear-gradient(rgba(0,0,0,0.5), transparent);"
        >
          <span
            class="white--text subtitle font-weight-bold"
            style="opacity: 1 !important"
          >{{ course.titulo }}</span>
        </div>
      </v-carousel-item>
    </v-carousel>
  </div>
</template>

<script>
import { mapState } from "vuex";

import store from "@/store";

export default {
  computed: {
    ...mapState(["siteSettings", "courses"]),
    coursesActives() {
      return this.courses ? this.courses.filter(course => course.estado) : [];
    }
  },
  data() {
    return {
      dialogCourse: false,
      courseSelect: undefined
    };
  },
  created() {
    this.retrieveCourses();
  },
  methods: {
    retrieveCourses() {
      if (!this.courses) {
        store
          .dispatch("retrieveCourses")
          .then(() => {})
          .finally(() => {});
      }
    }
  }
};
</script>

<style>
</style>